import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/home/home.routes').then(m => m.HOME_ROUTES)
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.LOGIN_ROUTES)
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.SIGNUP_ROUTES)
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.FORGOT_PASSWORD_ROUTES)
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.RESET_PASSWORD_ROUTES)
  },
  {
    path: 'tasks',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/tasks/tasks.routes').then(m => m.TASKS_ROUTES)
  },
  {
    path: 'lists',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/lists/lists.routes').then(m => m.LISTS_ROUTES)
  },
  {
    path: 'calendar',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/calendar/calendar.routes').then(m => m.CALENDAR_ROUTES)
  },
  {
    path: 'today',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/today/today.routes').then(m => m.TODAY_ROUTES)
  },
  {
    path: 'goals',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/goals/goals.routes').then(m => m.GOALS_ROUTES)
  },
  {
    path: 'notes',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/notes/notes.routes').then(m => m.NOTES_ROUTES)
  },
  {
    path: 'activities',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/activities/activities.routes').then(m => m.ACTIVITIES_ROUTES)
  },
  {
    path: 'meals',
    canActivate: [authGuard],
    loadChildren: () => import('./features/meals/meals.routes').then(m => m.MEALS_ROUTES)
  },
  {
    path: 'culture',
    redirectTo: 'mediatheque',
    pathMatch: 'prefix'
  },
  {
    path: 'mediatheque',
    canActivate: [authGuard],
    loadChildren: () => import('./features/culture/culture.routes').then(m => m.CULTURE_ROUTES)
  },
  {
    path: 'sport',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/sport/sport.routes').then(m => m.SPORT_ROUTES)
  },
  {
    path: 'measurements',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/health/health.routes').then(m => m.HEALTH_ROUTES)
  },
  {
    path: 'domains',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/domains/domains.routes').then(m => m.DOMAINS_ROUTES)
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
